const NON_ALPHANUM = /[^A-Z0-9]/g
const FORMAT_CHARS = /[./-]/g

function sanitize(value: string): string {
  const upper = (value || '').toUpperCase().replace(NON_ALPHANUM, '')
  if (upper.length <= 12) return upper
  const base = upper.slice(0, 12)
  const dv = upper.slice(12, 14).replace(/[^0-9]/g, '')
  return (base + dv).slice(0, 14)
}

export default function cnpjMask(value: string): string {
  if (!value) return ''
  const v = sanitize(value)
  if (v.length <= 2) return v
  if (v.length <= 5) return `${v.slice(0, 2)}.${v.slice(2)}`
  if (v.length <= 8) return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5)}`
  if (v.length <= 12)
    return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8)}`
  return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(
    8,
    12,
  )}-${v.slice(12, 14)}`
}

export function removeCnpjMask(value: string): string {
  return (value || '').toUpperCase().replace(FORMAT_CHARS, '')
}
